import $ from 'jquery';
import {
	getPreviouslySelectedTicketCategoryId,
	savePreviouslySelectedTicketCategoryId
} from '../../helpers/tripHighlightsCookie';
import abTestService from '../../services/abTestService';

const DISABLED_VARIATION_NAME = 'highlightPreviouslySelectedTicket_no';

class PreviouslySelectedTicketCategoriesComponent {
	#arrangementId;
	#isEnabledPromise;

	/**
	 * @param {number} arrangementId
	 */
	constructor(arrangementId) {
		this.#arrangementId = arrangementId;
		this.#isEnabledPromise = abTestService.whenAssignmentsReady()
			.then(() => !abTestService.isVariationActive(DISABLED_VARIATION_NAME));

		this.#init();
	}

	#init() {
		this.#isEnabledPromise
			.then((isEnabled) => {
				if (isEnabled) {
					this.highlightPreviouslySelectedTicketCategory();
				}
			})
			.catch(console.error);

		$(document).on(
			'widgetBookButtonClick',
			() => {
				this.#isEnabledPromise
					.then((isEnabled) => {
						if (isEnabled) {
							savePreviouslySelectedTicketCategoryId(
								this.#arrangementId,
								this.#getSelectedTicketCategoryId()
							);
						}
					})
					.catch(console.error);
			}
		);
	}

	highlightPreviouslySelectedTicketCategory() {
		const previousId = getPreviouslySelectedTicketCategoryId(this.#arrangementId);

		if (previousId === null) {
			return;
		}

		const $ticketCategory = $(`.ticket-category[data-ticket-category-id="${previousId}"]`);

		$ticketCategory.addClass('wasPreviouslySelected');
		$ticketCategory.closest('.ticket-category-container').addClass('wasPreviouslySelected');
	}

	/**
	 * @returns {number}
	 */
	#getSelectedTicketCategoryId() {
		const selectedTicketCategoryIdInput = $('.ticketCategoryIdInput:checked');

		return Number(selectedTicketCategoryIdInput.data('ticketid'));
	}
}

export default PreviouslySelectedTicketCategoriesComponent;